import { useUiStore } from '../../stores/uiStore'

export function ToastContainer() {
  const { toasts, removeToast } = useUiStore()

  if (!toasts.length) return null

  return (
    <div className="fixed bottom-4 right-4 z-50 flex flex-col gap-2">
      {toasts.map((t) => (
        <div
          key={t.id}
          className={`
            animate-slide-up flex items-center gap-3 px-4 py-3 rounded-lg shadow-lg
            text-white text-sm font-medium min-w-[220px] max-w-xs cursor-pointer
            ${t.type === 'error' ? 'bg-red-600' : t.type === 'success' ? 'bg-green-600' : 'bg-bg-input'}
          `}
          onClick={() => removeToast(t.id)}
        >
          {t.type === 'error' && <span>✕</span>}
          {t.type === 'success' && <span>✓</span>}
          {t.type === 'info' && <span>ℹ</span>}
          <span>{t.message}</span>
        </div>
      ))}
    </div>
  )
}
